import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useVerifyEmail } from '../../api/hooks/useAuth.ts';
import { AuthCard, FormError, FormNotice } from '../../components/AuthCard.tsx';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const verify = useVerifyEmail();
  // mutate is stable; run exactly once for the token in the URL
  const { mutate } = verify;
  useEffect(() => {
    if (token) mutate(token);
  }, [token, mutate]);

  return (
    <AuthCard title="Email verification">
      {!token && <FormError message="Missing verification token." />}
      {verify.isPending && <p className="text-center text-sm text-gray-500">Verifying…</p>}
      {verify.isError && (
        <FormError message="This verification link is invalid or has expired. Request a new one from the sign-in page." />
      )}
      {verify.isSuccess && (
        <>
          <FormNotice message="Your email address is verified. You can sign in now." />
          <Link className="block text-center text-sm text-blue-600 hover:underline" to="/login">
            Go to sign in
          </Link>
        </>
      )}
    </AuthCard>
  );
}
